export const isOnTopEnd = (elem, deltaY) => {
  return (elem.scrollTop + deltaY <= 0) && (elem.scrollTop === 0);
};

export const isOnBottomEnd = (elem, deltaY) => {
  return (elem.offsetHeight + elem.scrollTop + deltaY >= elem.scrollHeight) && (elem.scrollTop === elem.scrollHeight - elem.offsetHeight);
};

export const getAncestorsBetween = (el, target) => {
  const nextEl = el.parentNode;
  if (
    !nextEl
    || nextEl === target
  ) {
    return [];
  }

  return [nextEl].concat(getAncestorsBetween(nextEl, target));
};

export const getScrollTopToTarget = (el, targetEl) => {
  if (!el) {
    return 0;
  }

  if (el === targetEl) {
    return 0;
  }

  const offsetParent = el.offsetParent;
  const hasTargetInAncestors = getAncestorsBetween(el, offsetParent)
    .some((e) => e === targetEl);
  if (hasTargetInAncestors) {
    return el.offsetTop;
  }

  return el.offsetTop + getScrollTopToTarget(offsetParent, targetEl);
};
